// removed by extract-text-webpack-plugin
module.exports = {"formBox":"LGmBCgS89UBXeyIKs0oF7","choreTitle":"_1dlfifibEIkvkgIZMhO9TH","pointContain":"_2px8NkHJG2qBWY9R9VYOcV","weekContain":"_3NujRvrnX-8_VT68niBXPN","pointField":"VNp97wtu-jIxtmMSVLP1E","weekField":"_2JSYJitxLU362R-F235mMO","buttonBox":"RKgA_e6E3-SgMl73TG3Y6","saveButton":"Dk4Fb6-WGrioLmNGbLQCV","cancelButton":"S70Opmc5XUQseGEtUWDdA","validate":"_3PCGSAw5JMzjbam6bEFmKq"};


//////////////////
// WEBPACK FOOTER
// ./src/componentStyles/EditChore.css
// module id = 386
// module chunks = 0